var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineErrors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M120 54H72m48 24H72m78 28V30a6 6 0 0 0-6-6H48a6 6 0 0 0-6 6v132a6 6 0 0 0 6 6h46.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M96 144a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M138.5 174c12.979 0 23.5-10.521 23.5-23.5S151.479 127 138.5 127 115 137.521 115 150.5s10.521 23.5 23.5 23.5Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M138.5 173c12.426 0 22.5-10.074 22.5-22.5S150.926 128 138.5 128 116 138.074 116 150.5s10.074 22.5 22.5 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M139 141v10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M139 165a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineErrors);
export default __webpack_public_path__ + "static/media/MachineErrors.02815926e4d8688774085d99283b124f.svg";
export { ForwardRef as ReactComponent };